import React, {Component, createRef} from 'react'
import PropTypes from 'prop-types'

/**
 * Modal xác nhận dựng theo đúng .modal của mockup:
 * tiêu đề 18px, nội dung 13px muted, hai nút Huỷ / hành động (đỏ) căn phải.
 */
class ConfirmActionModal extends Component {
    _okRef = createRef()
    _prevOverflow = ''

    componentDidMount() {
        document.addEventListener('keydown', this._handleKeyDown)

        // Khoá cuộn nền như reactstrap Modal đang làm ở các màn khác,
        // nếu không trang phía sau vẫn cuộn được dưới lớp overlay đứng yên.
        this._prevOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'

        if (this._okRef.current) this._okRef.current.focus()
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this._handleKeyDown)
        document.body.style.overflow = this._prevOverflow
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') this.props.onCancel()
    }

    render() {
        const {title, content, okText, cancelText, onOk, onCancel} = this.props

        return (
            <div className="ps-modal-bg" onClick={onCancel}>
                <div
                    className="ps-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-label={typeof title === 'string' ? title : undefined}
                    onClick={e => e.stopPropagation()}
                >
                    <h3>{title}</h3>
                    <p>{content}</p>
                    <div className="ps-modal-row">
                        <button type="button" className="ps-btn ps-btn-ghost" onClick={onCancel}>{cancelText}</button>
                        <button type="button" className="ps-btn ps-btn-danger" ref={this._okRef} onClick={onOk}>
                            {okText}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

ConfirmActionModal.defaultProps = {
    okText: 'Xoá',
    cancelText: 'Huỷ',
}

ConfirmActionModal.propTypes = {
    title: PropTypes.node,
    content: PropTypes.node,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

export default ConfirmActionModal
